import { API_URL } from './consts'

export const loginEndpoint = `${API_URL}/login`
export const registerEndpoint = `${API_URL}/register`
export const forgotPasswordEndpoint = `${API_URL}/forgot_password`
export const resetPasswordEndpoint = `${API_URL}/reset_password`
export const getAllAssistants = `${API_URL}/users?filter=role&value=Assistant`